import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import useReactSelectCustomStyle from '../../hooks/useReactSelectCustomStyle';
import { updateClientLicenseStatusAPI } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getClientLicenseList } from '../../slices/LicenseList/thunk';

export default function EditStatusModal({
    editStatusLicenseModal,
    handleStatusEdit,
    licenseData,
}) {
    const params = useParams();
    const dispatch = useDispatch();

    const selectBoxCustomStyles = useReactSelectCustomStyle();

    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const statusOptions = [
        { value: 'ACTIVE', label: 'ACTIVE' },
        { value: 'INACTIVE', label: 'INACTIVE' },
    ];

    useEffect(() => {
        if (licenseData?.status) {
            const defaultStatus = statusOptions.find(
                (option) => option.value === licenseData.status
            );
            setStatus(defaultStatus || { label: 'ACTIVE', value: 'ACTIVE' });
        }
    }, [licenseData]);

    const handleStatusChange = (selectedOption) => {
        setStatus(selectedOption);
    };

    const submitStatusChange = async () => {
        setLoading(true);
        const data = {
            id: licenseData.id,
            status: status.value,
        };
        try {
            const apiResponse = await updateClientLicenseStatusAPI(data);
            if (apiResponse.status === 200) {
                dispatch(getClientLicenseList(params.id));
                toast.success('Status Updated Successfully');
                handleStatusEdit();
            } else {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            toast.error('An error occurred while updating status');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={editStatusLicenseModal} toggle={handleStatusEdit} size="sm" backdrop={'static'}>
            <ModalHeader toggle={handleStatusEdit}>Edit Status</ModalHeader>
            <ModalBody>
                <div>
                    <label htmlFor="statusSelect" className="form-label">
                        Select Status
                    </label>
                    <Select
                        id="statusSelect"
                        options={statusOptions}
                        value={status}
                        onChange={handleStatusChange}
                        className="basic-single"
                        classNamePrefix="select"
                        styles={selectBoxCustomStyles}
                    />
                </div>
                <div className="mt-3 text-end">
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={submitStatusChange}
                        disabled={loading}
                    >
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
}